<template>
  <div class="p-the-l04-header">
    <p class="p-the-l04-header__title">{{ title }}</p>
    <div class="p-the-l04-header__info">
      <div class="p-the-l04-header__info__item">
        掲載日時：{{ customDateFormat(publishedAt) }}
      </div>
      <div class="p-the-l04-header__info__item">
        更新日時：{{ customDateFormat(updatedAt) }}
      </div>
      <div class="p-the-l04-header__info__item">
        作成者：{{ authorName }} (ID: {{ authorId }})
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    title: { type: String, required: true },
    publishedAt: { type: String, required: true },
    updatedAt: { type: String, required: true },
    authorName: { type: String, required: true },
    authorId: { type: String, required: true }
  }
})
export default class TheK01Header extends Vue {
  title!: string;
  publishedAt!: string;
  updatedAt!: string;
  authorName!: string;
  authorId!: string;
  customDateFormat(value: string) {
        return value.split("T")[0];
      }
}
</script>

<style lang="scss" scoped>
.p-the-l04-header {
  padding-bottom: rem(8);
  border-bottom: px(1) solid $common-gray-border;

  @include sp {
    padding-bottom: rem(16);
  }

  &__title {
    font-size: $text-size__title--m;
    line-height: rem(32);
    color: #4f4f4f;

    @include sp {
      font-size: $text-size__body--l;
      line-height: rem(20);
    }
  }

  &__info {
    display: flex;
    margin-top: rem(8);

    @include sp {
      display: block;
    }

    &__item {
      @include text__body--s;
      color: #828282;
      margin-right: rem(24);
      line-height: rem(20);

      @include sp {
        @include text__body--xs;
        margin-right: 0;
        line-height: rem(18);
      }
    }
  }
}
</style>
